import { Source } from './Source';

export const CheckoutType = {
  TangoCard: 'tango-card',
  ExternalCheckout: 'external-checkout',
  Giftbox: 'giftbox',
  VirtualProduct: 'virtual-product',
  GikPremium: 'gik-premium',
} as const;

export type ProductCheckoutType = typeof CheckoutType[keyof typeof CheckoutType];

export interface Product {
  id: number;
  groupedProductIds: number[]; // for "Grouped" products - e.g. gift box + gift card bundle
  giftCardCategoryIds: number[];
  name: string;
  description: string;
  shortDescription: string;
  disclaimer: string;
  terms: string;
  sku: string;
  price: number;
  checkoutType: ProductCheckoutType;
  shippingRequired: boolean;
  shippingTaxable: boolean;
  type: 'fixed' | 'input' | 'select';
  thumbnails: string[];
  gridImage: string;
  images: string[];
  variations: ProductVariation[];
  productNonD2CUrl: string;
  sources: Source[];
  isInternalProduct: boolean;
  isTangoCardProduct: boolean;
  disableInterstitial: boolean;
  isHiddenProduct: boolean;
  isNonD2C: boolean;
  slug: string;
}

export interface ProductVariation {
  id: number;
  name: string;
  price: number;
  quantity: number;
  minValue?: number;
  maxValue?: number;
}

export interface ProductAttribute {
  id: number;
  name: string;
  position: number;
  visible: boolean;
  variation: boolean;
  options: string[];
}
